import styled from 'styled-components';

export const Wrapper = styled.span<{ size?: 'small' | 'medium' | 'large' }>`
  color: purple;
  font-size: ${(props) => (props.size === 'large' ? '16px' : props.size === 'medium' ? '14px' : '12px')};
  font-weight: normal;
  background-image: linear-gradient(to left, var(--primary), purple);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const Icon = styled.span`
  position: relative;
  top: 2px;
`;
